import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../config/config";

export function AddSubcategory() {
  const userId = localStorage.userId;
  const [animalType, setAnimalType] = useState([]);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    animalType: "",
    name: "",
    Price: "",
    Day1Limit: "",
    Day2Limit: "",
    Day3Limit: "",
    WeightLimit: "",
    DeductionRate: ""
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${config.baseUrl}/api/subcategories/animal-type`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Failed to fetch animal types');
        const data = await response.json();
        setAnimalType(data);
      } catch (error) {
        console.error("Failed to fetch animal types", error);
        setAnimalType([]);
      }
    };
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.animalType) newErrors.animalType = "Animal type is required.";
    if (!formData.name) newErrors.name = "Sub category name is required.";
    if (!formData.Price) newErrors.Price = "Price is required.";
    if (!formData.WeightLimit || formData.WeightLimit <= 0) newErrors.WeightLimit = "Weight limit must be greater than 0.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${config.baseUrl}/api/subcategories/addsubcat`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
          body: JSON.stringify({ ...formData, userId })
        });
        if (!response.ok) throw new Error('Failed to add subcategory');
        alert("Sub Category added successfully");
        navigate("/subcategories/view");
      } catch (error) {
        console.error("Error adding subcategory:", error);
        alert("Failed to add subcategory. Please try again.");
      }
    }
  };

  const inputCls = (field) =>
    `w-full px-3 py-2.5 rounded-lg border text-sm bg-gray-50 outline-none transition-all focus:ring-2 focus:ring-blue-500 focus:bg-white ${
      errors[field] ? "border-red-400 bg-red-50" : "border-gray-200"
    }`;

  const labelCls = "block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5";

  return (
    <div className="min-h-screen p-2">
      <div className="max-w-2xl mx-auto">

        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-black text-slate-800 uppercase tracking-tight">Add Sub Category</h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">

          {/* Basic Info Card */}
          <div className="rounded-2xl border border-slate-800 shadow-sm overflow-hidden">
            <div className="px-5 py-3 border-b border-slate-100 bg-indigo-800 ">
              <h2 className="text-xs font-black text-white uppercase tracking-widest">Basic Info</h2>
            </div>
            <div className="p-5 grid grid-cols-1 bg-white md:grid-cols-2 gap-4">

              {/* Animal Type */}
              <div className="md:col-span-2">
                <label className={labelCls}>Type of Animal</label>
                <select
                  name="animalType"
                  value={formData.animalType}
                  onChange={handleInputChange}
                  className={inputCls("animalType")}
                >
                  <option value="">Select Animal Type</option>
                  {animalType.map((type) => (
                    <option key={type.id} value={type.id}>{type.cat_name}</option>
                  ))}
                </select>
                {errors.animalType && <p className="text-red-500 text-xs mt-1">{errors.animalType}</p>}
              </div>

              {/* Sub Category Name */}
              <div className="md:col-span-2">
                <label className={labelCls}>Sub Category Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className={inputCls("name")}
                  placeholder="e.g. Premium Cow"
                />
                {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
              </div>

              {/* Price */}
              <div>
                <label className={labelCls}>Price (Rs.)</label>
                <input
                  type="number"
                  name="Price"
                  value={formData.Price}
                  onChange={handleInputChange}
                  className={inputCls("Price")}
                  placeholder="0"
                />
                {errors.Price && <p className="text-red-500 text-xs mt-1">{errors.Price}</p>}
              </div>

              {/* Weight Limit */}
              <div>
                <label className={labelCls}>Weight Limit (kg)</label>
                <input
                  type="number"
                  name="WeightLimit"
                  value={formData.WeightLimit}
                  onChange={handleInputChange}
                  className={inputCls("WeightLimit")}
                  placeholder="0"
                />
                {errors.WeightLimit && <p className="text-red-500 text-xs mt-1">{errors.WeightLimit}</p>}
              </div>

              {/* Deduction Rate */}
              <div className="md:col-span-2">
                <label className={labelCls}>Deduction Rate (%)</label>
                <input
                  type="number"
                  name="DeductionRate"
                  value={formData.DeductionRate}
                  onChange={handleInputChange}
                  className={inputCls("DeductionRate")}
                  placeholder="0"
                />
              </div>
            </div>
          </div>

          {/* Day Limits Card */}
          <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
            <div className="px-5 py-3 border-b border-slate-100 bg-indigo-800">
              <h2 className="text-xs font-black text-white uppercase tracking-widest">Day Limits</h2>
            </div>
            <div className="p-5 grid grid-cols-3 gap-4">
              {[1, 2, 3].map((day) => (
                <div key={day}>
                  <label className={labelCls}>Day {day}</label>
                  <input
                    type="number"
                    name={`Day${day}Limit`}
                    value={formData[`Day${day}Limit`]}
                    onChange={handleInputChange}
                    className={inputCls(`Day${day}Limit`)}
                    placeholder="0"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Buttons */}
          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="flex-1 py-3 rounded-xl border border-slate-200 bg-white text-slate-600 font-bold text-sm hover:bg-slate-100 transition-all"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 py-3 bg-indigo-800 text-white rounded-xl font-black text-sm uppercase tracking-widest hover:bg-blue-700 active:scale-95 transition-all shadow-lg shadow-blue-200"
            >
              Add Sub Category
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}